/**
 * Waitlist Form & Persona Selector
 */
export const initWaitlistForm = () => {
	const buttons = document.querySelectorAll('.waitlist-persona-btn');
	const heading = document.getElementById('form-persona-heading');
	const hiddenField = document.getElementById('waitlist-persona-field');
	const form = document.getElementById('waitlist-interactive-form');
	const successMsg = document.getElementById('waitlist-success-msg');

	if (form) {
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			form.classList.add('hidden');
			if (successMsg) {
				successMsg.classList.remove('hidden');
			}
		});
	}

	const titles = {
		family: 'Priority Registration — Family / Patient',
		nri: 'Priority Registration — NRI Family Member',
		doctor: 'Physician Partnership & Referral Registration',
		hospital: 'Hospital Institutional Partnership Registration',
		caregiver: 'Caregiver & Nurse Network Application',
		partner: 'Service Partner & Diagnostics Application',
	};

	buttons.forEach((btn) => {
		btn.addEventListener('click', function () {
			const persona = this.getAttribute('data-persona');
			buttons.forEach((b) => {
				b.classList.remove('border-primary', 'bg-teal-soft', 'shadow-soft', 'ring-2', 'ring-primary/30');
				b.classList.add('border-border', 'bg-card');
				b.setAttribute('aria-checked', 'false');
			});
			this.classList.remove('border-border', 'bg-card');
			this.classList.add('border-primary', 'bg-teal-soft', 'shadow-soft', 'ring-2', 'ring-primary/30');
			this.setAttribute('aria-checked', 'true');

			if (titles[persona] && heading) {
				heading.textContent = titles[persona];
			}
			if (hiddenField) {
				hiddenField.value = persona;
			}
		});
	});
};

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initWaitlistForm);
	} else {
		initWaitlistForm();
	}
}

